"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SpinnerSize = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../utils");

var _text = require("../text");

var _layout = require("../layout");

var _ProgressArc = require("./ProgressArc");

var _utils2 = require("./utils");

var rotate = (0, _core.keyframes)({
  from: {
    transform: 'rotate(0deg)'
  },
  to: {
    transform: 'rotate(360deg)'
  }
});
var SpinnerSize;
exports.SpinnerSize = SpinnerSize;

(function (SpinnerSize) {
  SpinnerSize["Small"] = "s";
  SpinnerSize["Medium"] = "m";
  SpinnerSize["Large"] = "l";
})(SpinnerSize || (exports.SpinnerSize = SpinnerSize = {}));

var getSpinnerDimension = function getSpinnerDimension(size) {
  switch (size) {
    case SpinnerSize.Small:
      return 28;

    case SpinnerSize.Medium:
      return 70;

    case SpinnerSize.Large:
      return 104;

    default:
      return size;
  }
};

var SpinnerComponent = function SpinnerComponent(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? SpinnerSize.Small : _ref$size,
      _ref$start = _ref.start,
      start = _ref$start === void 0 ? 0 : _ref$start,
      _ref$progress = _ref.progress,
      progress = _ref$progress === void 0 ? 0.66666 : _ref$progress,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      _ref$opacity = _ref.opacity,
      opacity = _ref$opacity === void 0 ? 0.5 : _ref$opacity,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? 4 : _ref$strokeWidth,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin,
      _ref$loadingText = _ref.loadingText,
      loadingText = _ref$loadingText === void 0 ? 'Loading...' : _ref$loadingText,
      _ref$showText = _ref.showText,
      showText = _ref$showText === void 0 ? false : _ref$showText,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? 'accent2' : _ref$textColor,
      outerProps = (0, _objectWithoutProperties2.default)(_ref, ["size", "start", "progress", "color", "opacity", "strokeWidth", "margin", "loadingText", "showText", "textColor"]);
  var isSmall = size === SpinnerSize.Small || size <= 28;
  var DisplayComponent = isSmall ? _layout.Row : _layout.Col;
  var gridGap = isSmall ? 8 : 16;
  var dimension = typeof size === 'number' ? size : getSpinnerDimension(size); // This should be refactored before the major version release by removing ProgressArcPath.
  // https://sim.amazon.com/issues/StencilDevelopment-1191

  var path = typeof size === 'number' ? (0, _ProgressArc.calculateProgressArcPath)({
    progress: progress,
    size: size,
    start: start,
    strokeWidth: strokeWidth,
    color: color,
    opacity: opacity
  }) : (0, _utils2.calculateSpinnerPath)({
    size: size,
    color: color
  });
  return (0, _core.jsx)(DisplayComponent, {
    alignItems: "center",
    gridGap: gridGap,
    margin: margin
  }, (0, _core.jsx)("svg", (0, _extends2.default)({
    role: "img",
    width: dimension,
    height: dimension,
    "aria-hidden": showText,
    xmlns: "http://www.w3.org/2000/svg"
  }, outerProps), !showText && loadingText && (0, _core.jsx)("title", null, loadingText), path), showText && loadingText && (0, _core.jsx)(_text.Text, {
    fontSize: "T100",
    color: textColor,
    textAlign: "center"
  }, loadingText));
};

var SpinnerBase = (
/*#__PURE__*/
0, _styledBase.default)(SpinnerComponent, {
  target: "ekdk61i0"
})(function (_ref2) {
  var speed = _ref2.speed;

  if (speed === 0) {
    return {
      animation: 'none'
    };
  }

  var time = speed ? 1 / speed : 1;
  return {
    animation: "".concat(time, "s linear 0s infinite normal none running ").concat(rotate)
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
SpinnerBase.defaultProps = {
  start: 0,
  progress: 0.66666,
  opacity: 0.5,
  strokeWidth: 4,
  margin: 0,
  loadingText: 'Loading...',
  showText: false,
  textColor: 'accent2',
  speed: 1.25,
  size: SpinnerSize.Small,
  color: 'primary'
};
var SpinnerBaseWithDocs = (0, _stencilReactDesc.describe)(SpinnerBase).description('Animated loading indicator.');
SpinnerBaseWithDocs.propTypes = {
  loadingText: _stencilReactDesc.PropTypes.string.description('Text that describes the loading.'),
  showText: _stencilReactDesc.PropTypes.bool.description('Determines whether to show the loading text. When false, the text is instead used as alt text for the image.'),
  textColor: _stencilReactDesc.PropTypes.string.description('Color of the displayed text.'),
  size: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.number, _stencilReactDesc.PropTypes.string]).description('Diameter of the arc, either in pixels or as a named size.'),
  start: _stencilReactDesc.PropTypes.number.description('Angle from the top of the arc to start the colored segment, in degrees.'),
  progress: _stencilReactDesc.PropTypes.number.description('Amount of the arc to fill with the colored segment, as a value between 0 and 1.'),
  color: _stencilReactDesc.PropTypes.string.description('Color to use for the colored segment.'),
  opacity: _stencilReactDesc.PropTypes.number.description('Opacity of the unfilled section of the arc, as a value between 0 and 1.'),
  strokeWidth: _stencilReactDesc.PropTypes.number.description('Width of the arc stroke, in pixels.'),
  margin: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.number]).description('Margin around the entire element.'),
  speed: _stencilReactDesc.PropTypes.number.description('Defines speed of the rotation.')
};
var Spinner = (0, _utils.withTestAttributes)({
  component: 'StencilReactSpinner'
})(SpinnerBaseWithDocs);
Spinner.displayName = 'Spinner';
var _default = Spinner;
exports.default = _default;